import NextHead from "../components/Seo/NextHead";
import Layout from "../components/Layout";
import BreadcrumbComponent from "../components/UserInterface/BreadcrumbComponent";
import { defaultURL, hubungKamiMeta } from "../data/DataMetatags";
import { hubungiKamiBreadcrumb } from "../data/DataBreadcrumb";
import LayoutCenter from "../components/UserInterface/LayoutCenter";
import Description from "../components/UserInterface/Description";
import Images from "../components/UserInterface/Images";
import contactUsIllustration from "../../public/static/images/png/ilustrasi-hubungi-kami.png";
import ContactForm from "../components/ContactUs/ContactForm";
import HeadingComponent from "../components/UserInterface/HeadingComponent";
import { useEffect, useState } from "react";
import UseWindowSize from "../components/UseWindowSize";
import DefaultContactInformation from "src/components/UserInterface/DefaultContactInformation";

const hubungiKami = ({ pageTitle, descriptionSEO, asPath }) => {
  const { width } = UseWindowSize();
  const [winSize, setWinSize] = useState(null);

  useEffect(() => {
    setWinSize(width);
  });
  const breadcrumb = [
    {
      "@type": "ListItem",
      position: "1",
      item: {
        "@id": defaultURL,
        name: "Home"
      }
    },
    {
      "@type": "ListItem",
      position: "2",
      item: {
        "@id": defaultURL + asPath,
        name: pageTitle
      }
    }
  ];
  return (
    <Layout>
      <NextHead
        title={pageTitle}
        description={descriptionSEO}
        url={asPath}
        breadcrumb={breadcrumb}
      />
      <BreadcrumbComponent items={hubungiKamiBreadcrumb}></BreadcrumbComponent>
      <HeadingComponent headingText="Hubungi Kami"></HeadingComponent>
      {winSize > 740 ? (
        <LayoutCenter>
          <LayoutCenter
            position="sticky"
            top="64px"
            alignSelf="flex-start"
            width="50%"
            column
          >
            <Description
              font="Roboto"
              align="left"
              text="Kami siap untuk membantu dan menjawab pertanyaan dari Pelanggan, Mitra, Media, dan pihak lainnya. Silakan isi formulir berikut untuk dihubungkan dengan Customer Care kami."
            ></Description>
            <Images width="460px" url={contactUsIllustration}></Images>
            <Description
              font="Roboto"
              align="left"
              text={`Temukan jawaban pertanyaanmu seputar produk dan layanan <a href="/pertanyaan-umum" target="_black" style="color: var(--color-red);font-family:Roboto; font-weight: bold;">Home Credit di halaman FAQ kami!</a>`}
            ></Description>
          </LayoutCenter>
          <ContactForm />
        </LayoutCenter>
      ) : (
        <LayoutCenter column margin="16px">
          <Description
            font="Roboto"
            align="left"
            text="Kami siap untuk membantu dan menjawab pertanyaan dari Pelanggan, Mitra, Media, dan pihak lainnya. Silakan isi formulir berikut untuk dihubungkan dengan Customer Care kami."
          ></Description>
          <ContactForm />
          <Description
            font="Roboto"
            align="left"
            text={`Temukan jawaban pertanyaanmu seputar produk dan layanan <a href="/pertanyaan-umum" target="_black" style="color: var(--color-red);font-family:Roboto; font-weight: bold;">Home Credit di halaman FAQ kami!</a>`}
          ></Description>
        </LayoutCenter>
      )}
      <DefaultContactInformation />
    </Layout>
  );
};

hubungiKami.getInitialProps = async ({ asPath }) => {
  const pageTitle = hubungKamiMeta.title;
  const descriptionSEO = hubungKamiMeta.description;
  return { pageTitle, descriptionSEO, asPath };
};
export default hubungiKami;
